import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useClient } from '@/context/client-context';
import { useAuth } from '@/contexts/AuthContext';
import SopAssessmentPage from '@/components/sop-intake/sop-analyzer/SopAssessmentPage';
import { getAssessment } from '@/components/sop-intake/services/assessments-api';
import { getClient } from '@/components/clients/services/clients-api';
import type { Assessment, Client } from '@/lib/types';

export default function SopViewPage() {
  const { client, setClient, isClientLoading } = useClient();
  const { user, loading: authLoading } = useAuth();
  const { id: clientId, assessmentId } = useParams<{ id: string; assessmentId: string }>();

  const [loading, setLoading] = useState(true);
  const [assessment, setAssessment] = useState<Assessment | null>(null);
  const [viewClient, setViewClient] = useState<Client | null>(client);

  useEffect(() => {
    const decodedAssessmentId = assessmentId ? decodeURIComponent(assessmentId) : '';
    const fetchData = async () => {
      setLoading(true);
      if (clientId && user && !authLoading) {
        if (!client || client.id !== clientId) {
          const fetchedClient = await getClient(clientId);
          if (fetchedClient) {
            setClient(fetchedClient);
            setViewClient(fetchedClient);
          }
        } else {
          setViewClient(client);
        }

        if (decodedAssessmentId) {
          const fetchedAssessment = await getAssessment(clientId, decodedAssessmentId);
          setAssessment(fetchedAssessment);
        }
      }
      setLoading(false);
    };

    fetchData();
  }, [client, clientId, assessmentId, authLoading, user, setClient]);

  if (isClientLoading || loading) {
    return (
      <div className="py-8 text-center text-muted-foreground">Loading assessment…</div>
    );
  }

  if (!clientId || !assessment || !viewClient) {
    return (
      <div className="py-8 text-center text-muted-foreground">Assessment or client data is missing.</div>
    );
  }

  return <SopAssessmentPage mode="edit" initialAssessmentData={assessment} />;
}
